import CheckOutlinedIcon from '@ant-design/icons/CheckOutlined'

import Button from '@mui/material/Button'

import { RoleGuard } from '@shared/providers/src/MeProvider'
import { AssessmentStatus, handleError, UserRole } from '@shared/utils'

import PatientAccessGuard from '@components/PatientAccessGuard'

import { useAssessmentReview } from '../AssessmentDetailsModal.hooks'

export default function ReviewActions({ patientId, encounterId, assessment, onSuccess }) {
  const reviewAssessment = useAssessmentReview(patientId, encounterId, assessment?.id)

  const handleReview = () =>
    reviewAssessment
      .mutateAsync()
      .then(() => onSuccess?.())
      .catch((e) => handleError(e, { showResponse: true }))

  if (!assessment || !patientId || !encounterId) return null

  return (
    <RoleGuard allowed={[UserRole.Provider]}>
      <PatientAccessGuard patientId={patientId}>
        {assessment.status === AssessmentStatus.Finished && (
          <Button variant="contained" loading={reviewAssessment.isPending} onClick={handleReview} sx={{ alignSelf: 'center' }}>
            Mark as Reviewed
          </Button>
        )}
        {assessment.status === AssessmentStatus.Reviewed && (
          <Button variant="outlined" sx={{ alignSelf: 'center' }} endIcon={<CheckOutlinedIcon />}>
            Reviewed
          </Button>
        )}
      </PatientAccessGuard>
    </RoleGuard>
  )
}
